import { watch, onUnmounted, type Ref } from 'vue'

/**
 * While `active` is true (a mobile bottom-sheet is open), lock body scroll and
 * close the sheet on Escape. Used by the step components that own a detail sheet
 * (ResultsStep, TopUpStep) so each manages its own sheet behavior.
 */
export function useSheetScrollLock(active: Ref<boolean>, close: () => void): void {
  function onKey(e: KeyboardEvent): void {
    if (e.key === 'Escape') close()
  }

  function teardown(): void {
    if (typeof document === 'undefined') return
    document.body.style.overflow = ''
    document.removeEventListener('keydown', onKey)
  }

  watch(active, (on) => {
    if (typeof document === 'undefined') return
    document.body.style.overflow = on ? 'hidden' : ''
    if (on) document.addEventListener('keydown', onKey)
    else document.removeEventListener('keydown', onKey)
  })

  onUnmounted(teardown)
}
